import { library } from '@fortawesome/fontawesome-svg-core';
import { faEdit, faUnlink } from '@fortawesome/free-solid-svg-icons';
import { observer } from 'mobx-react-lite';
import { ReactElement, useContext } from 'react';
import { S_Pagination } from '../../../../design/pagination/S_Pagination';
import { Thumbnails } from '../../../../design/thumbnails/Thumbnails';
import { ColumnLayout } from '../../../../modules/common/layouts/columnLayout/ColumnLayout';
import { Settings } from '../../../../modules/settings/SettingsContext';
import { Loader } from '../../../components/Loader';
import { scrollTop } from '../../../helpers/react.helpers';
import { IDatasetDetailsImage } from '../datasetsDetails.store';
import { IDatasetDetailsImagesProps } from './DatasetDetailsImagesList';
import { DatasetThumbnail } from './DatasetThumbnail';

library.add(faUnlink, faEdit);

export const DatasetDetailsImagesListThumbs = observer((props: IDatasetDetailsImagesProps): ReactElement => {
  const settingsContext = useContext(Settings);

  const handlePaginationChange = async (pageNumber: number, pageSize: number): Promise<void> => {
    scrollTop();
    settingsContext.setDatasetDetailsImagesPageSize(pageSize);
    await props.onPaginationChange(pageNumber, pageSize);
  };

  return (
    <ColumnLayout size='sm'>
      <Loader
        isLoading={props.isLoading}
        message={'Please wait, fetching the latest data...'}
      >
        <Thumbnails isLoading={props.isLoading}>
          {!props.isLoading &&
            props.datasetImages.map((image: IDatasetDetailsImage) => {
              return (
                <DatasetThumbnail
                  key={image.id}
                  workspaceId={props.workspaceId}
                  image={image}
                  disabled={props.disabled}
                  datasetId={props.datasetId}
                  authToken={props.authToken}
                  isChecked={props.imagesToBulkDelete.some((x) => x === image.id)}
                  onCheck={props.onThumbCheck}
                  onDelete={props.onImageDeleted}
                  onRename={props.onRenameImage}
                />
              );
            })}
        </Thumbnails>
        <S_Pagination
          pageNumber={props.paging.pageNumber}
          pageSize={props.paging.pageSize}
          totalCount={props.paging.totalCount}
          onChange={handlePaginationChange}
          pageSizeLabel='pagination.showImages'
        />
      </Loader>
    </ColumnLayout>
  );
});
